var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPencil = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-outline/pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.9645 11.9645L49.4645 7.46447C51.4171 5.51184 54.5829 5.51184 56.5355 7.46447C58.4882 9.41709 58.4882 12.5829 56.5355 14.5355L18.2192 52.8519C16.8094 54.2617 15.0705 55.298 13.1597 55.8672L6 58L8.13275 50.8403C8.70194 48.9295 9.73826 47.1907 11.1481 45.7809L44.9645 11.9645ZM44.9645 11.9645L52 19",
    stroke: "#2EC4B2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil.3730da68.svg";
export { ForwardRef as ReactComponent };